import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nProvider";

const container = { hidden: {}, show: { transition: { staggerChildren: 0.1 } } };
const item = { hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16,1,0.3,1] } } };

export function Value() {
  const { t, dict } = useI18n();
  const pillars = dict.value.pillars;

  return (
    <section className="relative py-20 lg:py-32 bg-[#0F172A] border-y border-slate-800/60" data-testid="value-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-emerald-500" />
              <p className="eyebrow">{t("value.eyebrow")}</p>
            </div>
            <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-balance">
              {t("value.heading")}
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-5">
            {["p1","p2","p3","p4"].map((k) => (
              <p key={k} className="text-base lg:text-lg text-slate-300 leading-relaxed">
                {t(`value.${k}`)}
              </p>
            ))}
          </div>
        </div>

        <motion.div
          className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={container}
        >
          {pillars.map((p, i) => (
            <motion.div key={i} variants={item} className="z-card p-6" data-testid={`value-pillar-${i + 1}`}>
              <span className="font-mono text-xs uppercase tracking-widest text-emerald-400">0{i + 1}</span>
              <h3 className="mt-4 font-display text-xl font-semibold">{p.title}</h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Value;
